/**
 * ATTENTION! This file is auto-generated for the 'telegram' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { TelegramBotRepository } from '../server/repositories/TelegramBotRepository';
import type { TelegramUserBindingRepository } from '../server/repositories/TelegramUserBindingRepository';
import type { TelegramPairingTokenRepository } from '../server/repositories/TelegramPairingTokenRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","meta","getInstance","columns","filters"];

type TelegramBotRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelegramBotRepository>;
export function useTelegramBotRepository(): TelegramBotRepositoryClient { return makeRepositoryProxy<TelegramBotRepositoryClient>('telegram::TelegramBotRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelegramBotRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telegramBotRepository = useTelegramBotRepository();

type TelegramUserBindingRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelegramUserBindingRepository>;
export function useTelegramUserBindingRepository(): TelegramUserBindingRepositoryClient { return makeRepositoryProxy<TelegramUserBindingRepositoryClient>('telegram::TelegramUserBindingRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelegramUserBindingRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telegramUserBindingRepository = useTelegramUserBindingRepository();

type TelegramPairingTokenRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelegramPairingTokenRepository>;
export function useTelegramPairingTokenRepository(): TelegramPairingTokenRepositoryClient { return makeRepositoryProxy<TelegramPairingTokenRepositoryClient>('telegram::TelegramPairingTokenRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelegramPairingTokenRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telegramPairingTokenRepository = useTelegramPairingTokenRepository();

type generatePersonalLinkType = typeof import('../server/functions/generatePersonalLink').generatePersonalLink;
export const generatePersonalLink: RpcFunctionClient<generatePersonalLinkType> = makeFunctionProxy<generatePersonalLinkType>('telegram::generatePersonalLink');

type getMyBindingType = typeof import('../server/functions/getMyBinding').getMyBinding;
export const getMyBinding: RpcFunctionClient<getMyBindingType> = makeFunctionProxy<getMyBindingType>('telegram::getMyBinding');

type removeMyBindingType = typeof import('../server/functions/removeMyBinding').removeMyBinding;
export const removeMyBinding: RpcFunctionClient<removeMyBindingType> = makeFunctionProxy<removeMyBindingType>('telegram::removeMyBinding');

type startBotType = typeof import('../server/functions/startBot').startBot;
export const startBot: RpcFunctionClient<startBotType> = makeFunctionProxy<startBotType>('telegram::startBot');

type stopBotType = typeof import('../server/functions/stopBot').stopBot;
export const stopBot: RpcFunctionClient<stopBotType> = makeFunctionProxy<stopBotType>('telegram::stopBot');
